<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstAttendance"
		[loading]="TableLoading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedAttendance"
		dataKey="RowID"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--PersonName-->
				<th>
					<p-columnFilter type="text" field="PersonName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--RawStudentID-->
				<th>
					<p-columnFilter type="text" field="RawStudentID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolName-->
				<th>
					<p-columnFilter field="SchoolName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSchoolName
								[ngModel]="value"
								[options]="lstSchoolName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--RawEntryDate-->
				<th>
					<p-columnFilter type="text" field="RawEntryDate" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--OldAttendanceStatusDesc-->
				<th>
					<p-columnFilter field="OldAttendanceStatusDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterOldAttendanceStatusDesc
								[ngModel]="value"
								[options]="lstOldAttendanceStatusDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--NewAttendanceStatusDesc-->
				<th>
					<p-columnFilter field="NewAttendanceStatusDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterNewAttendanceStatusDesc
								[ngModel]="value"
								[options]="lstNewAttendanceStatusDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--OldEntryTime-->
				<th>
					<p-columnFilter type="text" field="OldEntryTime" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--NewEntryTime-->
				<th>
					<p-columnFilter type="text" field="NewEntryTime" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--OldExcuseDesc-->
				<th>
					<p-columnFilter field="OldExcuseDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterOldExcuseDesc
								[ngModel]="value"
								[options]="lstOldExcuseDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--NewExcuseDesc-->
				<th>
					<p-columnFilter field="NewExcuseDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterNewExcuseDesc
								[ngModel]="value"
								[options]="lstNewExcuseDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--OldComments-->
				<th>
					<p-columnFilter type="text" field="OldComments" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--NewComments-->
				<th>
					<p-columnFilter type="text" field="NewComments" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--IsValidDesc-->
				<th>
					<p-columnFilter field="IsValidDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterIsValidDesc
								[ngModel]="value"
								[options]="lstIsValidDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="PersonName">Name<p-sortIcon field="PersonName"></p-sortIcon></th>
				<th pSortableColumn="RawStudentID">Student ID<p-sortIcon field="RawStudentID"></p-sortIcon></th>
				<th pSortableColumn="SchoolName">School<p-sortIcon field="SchoolName"></p-sortIcon></th>
				<th pSortableColumn="RawEntryDate">Attendance Date<p-sortIcon field="RawEntryDate"></p-sortIcon></th>
				<th pSortableColumn="OldAttendanceStatusDesc">Old Status<p-sortIcon field="OldAttendanceStatusDesc"></p-sortIcon></th>
				<th pSortableColumn="NewAttendanceStatusDesc">New Status<p-sortIcon field="NewAttendanceStatusDesc"></p-sortIcon></th>
				<th pSortableColumn="OldEntryTime">Old Entry Time<p-sortIcon field="OldEntryTime"></p-sortIcon></th>
				<th pSortableColumn="NewEntryTime">New Entry Time<p-sortIcon field="NewEntryTime"></p-sortIcon></th>
				<th pSortableColumn="OldExcuseDesc">Old Excuse<p-sortIcon field="OldExcuseDesc"></p-sortIcon></th>
				<th pSortableColumn="NewExcuseDesc">New Excuse<p-sortIcon field="NewExcuseDesc"></p-sortIcon></th>
				<th pSortableColumn="OldComments">Old Comments<p-sortIcon field="OldComments"></p-sortIcon></th>
				<th pSortableColumn="NewComments">New Comments<p-sortIcon field="NewComments"></p-sortIcon></th>
				<th pSortableColumn="IsValidDesc">Valid?<p-sortIcon field="IsValidDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Attendance>
			<tr [pSelectableRow]="Attendance">
				<td
					*ngFor="let col of cols"
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="Attendance.IsValid == true ? 'inherit' : 'Red'"
				>
					<span>{{ Attendance[col.field] }}</span>

					<!-- <span *ngIf="col.CanEditStatus == false && col.CanEditTime == false">{{ Attendance[col.field] }}</span>

					<select
						*ngIf="col.CanEditStatus == true"
						[disabled]="IsLoading() == true"
						class="form-control"
						name="NewAttendanceStatusID"
						[(ngModel)]="Attendance.NewAttendanceStatusID"
					>
						<option value="" style="display: none"></option>
						<option *ngFor="let o of lstAttendanceStatus" [ngValue]="o.ID">{{ o.Desc }}</option>
					</select>

					<p-calendar
						*ngIf="col.CanEditTime == true"
						timeOnly="true"
						[(ngModel)]="Attendance.NewEntryTimeDT"
						hourFormat="12"
						name="txtStartTime"
					></p-calendar> -->
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
